<div [class.dark-theme]="true" class="fix-action-dialog">
	<div fxLayout="row" fxLayoutAlign="start">
		<div class="card-title">
			<h2 mat-dialog-title style="font-size: 24px;color:#ffffff;font-weight: 600;"><span data-idtest="guests-dialog-t-8Ry">{{dialog_name}}</span></h2>
			<h2 data-idtest="guests-dialog-t-4Kp" mat-dialog-title style="font-size: 14px;color:#ffffff;font-weight: 600;"><span data-idtest="guests-dialog-t-3Ef" translate>メールアドレス</span>：{{content.username}}</h2>
			<h3 *ngIf="authIs('manager')" style="color:#ffffff;font-weight: 600;">{{content.stripe_id}}</h3>
		</div>
	</div>
	<mat-dialog-content>
		<div fxLayout="row" fxLayout.lt-sm="column" style="padding:8px">
			<form fxFlex.lt-sm="100" #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" style="margin:8px;" novalidate>
				<div fxLayout="row wrap" fxLayoutAlign="space-around">
					<mat-checkbox *ngIf="authIs('manager')" [(ngModel)]="content.accounting" name="accounting"><span data-idtest="guests-dialog-t-6Fd" style="color:#ffffff;" translate>請求書払いスタジオの場合はチェック</span></mat-checkbox>
					<span *ngIf="authIs('manager')">
						<mat-slide-toggle data-idtest="guests-dialog-s-6Qv" [(ngModel)]="content.enabled" [disabled]="false" labelPosition="before" class="example-margin" name="enable"><span data-idtest="guests-dialog-t-6Me" style="color:#ffffff;" translate>休止</span></mat-slide-toggle>
						<span data-idtest="guests-dialog-t-0Va" style="margin-left: 6px;color:#ffffff;" translate>有効</span>
					</span>
				</div>

				<mat-form-field style="margin: 12px;">
					<mat-label><span data-idtest="guests-dialog-t-6Fg" translate>会員名</span></mat-label>
					<input data-idtest="guests-dialog-i-1Ps" #nickname="ngModel" [(ngModel)]="content.nickname" autocomplete="off" matInput maxlength="255" minlength="2" name="nickname" placeholder="" required type="text">
					<mat-hint><span data-idtest="guests-dialog-t-6Io" translate>2文字以上255文字まで</span></mat-hint>
					<mat-error *ngIf="nickname.errors?.['required'];"><span translate>入力してください</span></mat-error>
					<mat-error *ngIf="nickname.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
					<mat-error *ngIf="nickname.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
				</mat-form-field>

				<div fxLayout="row wrap" fxLayoutAlign="space-around">
					<mat-form-field *ngIf="authIs('manager')">
						<mat-label><span data-idtest="guests-dialog-t-4Rr" translate>アカウント権限</span></mat-label>
						<mat-select data-idtest="guests-dialog-p-4Qi" #auth_select="ngModel" [(ngModel)]="content.auth" name="auth_select" required>
							<mat-option *ngFor="let auth of auths" [value]="auth.value">
								{{auth.name}}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="auth_select.errors?.['required'];"><span translate>入力してください</span></mat-error>
					</mat-form-field>
					<mat-form-field *ngIf="authIs('manager')">
						<mat-label><span data-idtest="guests-dialog-t-0Ap" translate>アカウント種別</span></mat-label>
						<mat-select data-idtest="guests-dialog-p-6En" #type_select="ngModel" [(ngModel)]="content.type" name="type_select">
							<mat-option *ngFor="let type of types" [value]="type.value">
								{{type.name}}
							</mat-option>
						</mat-select>
					</mat-form-field>

					<mat-form-field *ngIf="authEq('manager')">
						<mat-label><span translate>アカウント所属</span></mat-label>
						<mat-select #studio_select="ngModel" [(ngModel)]="content.parent" name="studio_select">
							<mat-option *ngFor="let studio of studios" [value]="studio.value">
								{{studio.name}}
							</mat-option>
						</mat-select>
					</mat-form-field>

				</div>
				<div fxLayout="row wrap" fxLayoutAlign="space-around">
					<mat-form-field>
						<mat-label><span data-idtest="guests-dialog-t-7Ui" translate>身長</span></mat-label>
						<div fxLayout="row">
							<input [(ngModel)]="content.height" matInput max="999" min="0" name="height" placeholder="" step="1" style="text-align: right;" type="number">
							<div data-idtest="guests-dialog-t-7Xy" translate>cm</div>
						</div>
					</mat-form-field>
					<mat-form-field>
						<mat-label><span data-idtest="guests-dialog-t-4Pd" translate>ゴルフ暦</span></mat-label>
						<div fxLayout="row">
							<input [(ngModel)]="content.experience" matInput max="999" min="0" name="experience" placeholder="" step="1" style="text-align: right;" type="number">
							<div data-idtest="guests-dialog-t-9Zx" translate>年</div>
						</div>
					</mat-form-field>
					<mat-form-field>
						<mat-label><span data-idtest="guests-dialog-t-8Pp" translate>平均スコア</span></mat-label>
						<input [(ngModel)]="content.score" matInput max="999" min="0" name="score" placeholder="" step="1" style="text-align: right;" type="number">
					</mat-form-field>
					<mat-form-field>
						<mat-label><span data-idtest="guests-dialog-t-9Ib" translate>ドライバーの距離</span></mat-label>
						<div fxLayout="row">
							<input [(ngModel)]="content.driver" matInput max="999" min="0" name="driver" placeholder="" step="1" style="text-align: right;" type="number">
							<div data-idtest="guests-dialog-t-8Gl" translate>Yard</div>
						</div>
					</mat-form-field>
					<mat-form-field>
						<mat-label><span data-idtest="guests-dialog-t-8Mr" translate>7番アイアンの距離</span></mat-label>
						<div fxLayout="row">
							<input [(ngModel)]="content.seveniron" matInput max="999" min="0" name="seveniron" placeholder="" step="1" style="text-align: right;" type="number">
							<div data-idtest="guests-dialog-t-1Ji" translate>Yard</div>
						</div>
					</mat-form-field>
					<mat-form-field>
						<mat-label><span data-idtest="guests-dialog-t-5Jj" translate>年間ラウンド回数</span></mat-label>
						<div fxLayout="row">
							<input [(ngModel)]="content.rounds" fxFlex="80" matInput max="999" min="0" name="rounds" placeholder="" step="1" style="text-align: right;" type="number">
							<div data-idtest="guests-dialog-t-6Uk" fxFlex translate>回</div>
						</div>
					</mat-form-field>
					<mat-form-field>
						<mat-label><span data-idtest="guests-dialog-t-4Xd" translate>月間練習回数</span></mat-label>
						<div fxLayout="row">
							<input [(ngModel)]="content.practice" fxFlex="80" matInput max="999" min="0" name="practice" placeholder="" step="1" style="text-align: right;" type="number">
							<div data-idtest="guests-dialog-t-9Cj" fxFlex translate>回</div>
						</div>
					</mat-form-field>
					<mat-form-field>
						<mat-label><span data-idtest="guests-dialog-t-0Xo" translate>オフィシャルハンディ</span></mat-label>
						<input [(ngModel)]="content.handicap" matInput max="99" min="0" name="handicap" placeholder="" step="1" style="text-align: right;" type="number">
					</mat-form-field>
				</div>
				<mat-form-field *ngIf="!authIs('studio')">
					<mat-label><span data-idtest="guests-dialog-t-4Fy" translate>詳細</span></mat-label>
					<textarea #description="ngModel" [(ngModel)]="content.description" matInput maxlength="255" name="description" placeholder="" type="text"></textarea>
					<mat-hint><span data-idtest="guests-dialog-t-9Mq" translate>3文字以上255文字まで</span></mat-hint>
					<mat-error *ngIf="description.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
				</mat-form-field>

				<div
					fxLayout="row wrap"
					fxLayoutAlign="space-around"
					*ngIf="authIs('studio')"
				>
					<mat-form-field
						[fxFlex]="
							authIs('manager')
								? 60
								: authIs('studio') &&
								  _.get(content, 'enable_reservation_link')
								? 60
								: 100
						"
					>
						<mat-label
							><span data-idtest="guests-dialog-t-4Fy" translate
								>詳細</span
							></mat-label
						>
						<textarea
							#description="ngModel"
							[(ngModel)]="content.description"
							matInput
							maxlength="255"
							name="description"
							placeholder=""
							type="text"
						></textarea>
						<mat-hint
							><span data-idtest="guests-dialog-t-9Mq" translate
								>3文字以上255文字まで</span
							></mat-hint
						>
						<mat-error *ngIf="description.errors?.['maxlength']"
							><span translate>長すぎます</span></mat-error
						>
					</mat-form-field>
					<div
						class="input-text"
						fxFlex="30"
						*ngIf="authIs('manager')"
						style="display: flex; flex-direction: column; gap: 10px"
					>
						<mat-label style="text-align: left; color: white"
							><span
								data-idtest="welcome-dialog-t-6Teasbc"
								translate
								>予約システム連携店舗</span
							></mat-label
						>
						<section style="display: flex">
							<mat-button-toggle-group
								class="store-link-toggle"
								data-idtest="shotdata-s-9Vl2ss"
								name="favoriteColor"
								[(ngModel)]="!!account.enable_reservation_link"
							>
								<mat-button-toggle [value]="false"
									>OFF</mat-button-toggle
								>
								<mat-button-toggle [value]="true"
									>ON</mat-button-toggle
								>
							</mat-button-toggle-group>
						</section>
					</div>

					<mat-form-field
						fxFlex="30"
						*ngIf="
							!authIs('manager') &&
							authIs('studio') &&
							_.get(content, 'enable_reservation_link')
						"
					>
						<mat-label
							><span data-idtest="welcome-dialog-t-9Tz" translate
								>予約システム連携ID</span
							></mat-label
						>

						<textarea
							data-idtest="welcome-dialog-i-4Mhdef"
							#reserv_id="ngModel"
							[(ngModel)]="content.reserv_id"
							matInput
							maxlength="40"
							name="reserv_id"
							placeholder="{{ '予約システム連携ID' | translate }}"
							type="text"
						></textarea>

						<mat-hint
							><span data-idtest="welcome-dialog-t-3Bt" translate
								>0文字以上40文字まで</span
							></mat-hint
						>

						<mat-error *ngIf="reserv_id.errors?.['maxlength']"
							><span translate>長すぎます</span></mat-error
						>
					</mat-form-field>
				</div>
			</form>
			<!-- <div fxFlex="40" fxFlex.lt-sm="100" style="margin:8px;">
				<div style="font-size: 14px; font-weight: 200; margin: 8px; color: #ffffff;"><span translate>このアカウントの所属</span></div>
				<belongs-panel #belongs_panel [auth]="auth" [account]="account"></belongs-panel>
			</div> -->
		</div>
	</mat-dialog-content>

	<div class="spacer"></div>

	<mat-dialog-actions fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around">
		<button data-idtest="guests-dialog-b-0Vy" (click)="cancel()" color="warn" mat-dialog-close="" mat-stroked-button id="mat-cancel-button"><span data-idtest="guests-dialog-t-5Sf" translate>キャンセル</span></button>
		<button data-idtest="guests-dialog-b-5Sv" (click)="onAccept()" [disabled]="form.invalid" color="primary" mat-raised-button id="mat-ok-button"><span data-idtest="guests-dialog-t-2Ur" translate>OK</span></button>
	</mat-dialog-actions>
</div>
